import { get, post, request } from "../util/crmAxios";
import { getBasicUrls } from "../util/config";

const schoolm = getBasicUrls().schoolm;
const prefix = `${schoolm}manage/supervisorApplyOrder/`;

// 督学申请单分页
export const querySupervisorApplyOrderPage = params => post(`${prefix}page`, params);

// 督学申请单导出
export const exportSupervisorApplyOrderPageUrl = `${prefix}exportSupervisorApplyOrderPage`;

// 督学申请单详情
export const getSupervisorApplyOrderDetail = params => get(`${prefix}detail`, params);

// 当前账号督学申请单权限
export const getSupervisorApplyOrderPermission = params => get(`${prefix}permission`, params);

// 选择关联销售单弹窗分页
export const querySupervisorApplySalesOrderPage = params => post(`${prefix}select/salesOrder/page`, params);

// 选择学生账号弹窗分页
export const querySupervisorApplyStudentPage = params => post(`${prefix}select/student/page`, params);

// 学员未核销完成督学申请列表
export const queryStudentUnconsumedSupervisorApplyOrders = params => post(`${prefix}student/unconsumed/list`, params);

// 新增督学申请单
export const saveSupervisorApplyOrder = params => post(`${prefix}save`, params);

// 修改督学申请单
export const updateSupervisorApplyOrder = params => post(`${prefix}update`, params);

// 取消督学申请单
export const cancelSupervisorApplyOrder = params => post(`${prefix}cancel`, params);

// 消课摘要预留接口
export const getSupervisorApplyConsumeSummary = params => get(`${prefix}consume/summary`, params);

// 督学申请单支付方式配置
export const querySupervisorApplyPayChannels = params => get(`${prefix}pay/channelList`, params);

// 支付凭证确认
export const voucherConfirmSupervisorApplyOrder = params => post(`${prefix}pay/voucherConfirm`, params);

// 汇付收银台支付
export const aggregateQrSupervisorApplyOrder = params => post(`${prefix}pay/aggregateQr`, params);

// 汇付收银台支付状态查询
export const querySupervisorApplyAggregatePayStatus = params => get(`${prefix}pay/status`, params);

// 退费预览
export const getSupervisorApplyRefundPreview = params => get(`${prefix}refund/preview`, params);

// 确认退费
export const refundSupervisorApplyOrder = params => post(`${prefix}refund`, params);

// 支付/退费凭证上传：复用现有 CRM 上传接口，走统一 axios 鉴权拦截器
export const uploadSupervisorApplyVoucherFile = formData => request({
  method: "post",
  url: "base/upload/uploadPicture?type=record",
  data: formData,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
